import CATALOGO from './permisosPuntoV.json';

// Catálogo de permisos de Punto V Manager (copia de
// puntov_manager/src/config/permissions.json). Solo da nombres, grupos y el
// árbol "requiere": qué permisos existen y sus ids los dice Punto V
// (GET /puntov/clientes/:base/permisos). Si allá se agrega un permiso que
// aquí no está, aparece en "Sin catalogar" hasta actualizar esta copia.

// Orden de PERMISSION_GROUPS en puntov_manager/src/config/permissions.ts.
const ORDEN_GRUPOS = [
  'Dashboard', 'Almacén', 'Máquinas', 'Tránsito', 'Reportes', 'Cupones',
  'Usuarios', 'Seguridad', 'Anuncios', 'Facturación', 'Cámaras', 'Administración'
];
export const SIN_CATALOGAR = 'Sin catalogar';

export const ETIQUETA_FEATURE = {
  invoice_restock: 'Facturas de proveedor',
  transit_restock: 'Tránsito',
  camera: 'Cámaras',
  notifications: 'Notificaciones'
};

const porCodigo = new Map(CATALOGO.map(p => [p.codigo, p]));
const padre = new Map(CATALOGO.filter(p => p.requiere).map(p => [p.codigo, p.requiere]));
const hijos = new Map();
padre.forEach((p, hijo) => hijos.set(p, [...(hijos.get(p) || []), hijo]));

export const ancestrosDe = (codigo) => {
  const acc = [];
  let actual = padre.get(codigo);
  while (actual && !acc.includes(actual)) {
    acc.push(actual);
    actual = padre.get(actual);
  }
  return acc;
};

export const descendientesDe = (codigo) =>
  (hijos.get(codigo) || []).flatMap(h => [h, ...descendientesDe(h)]);

const profundidad = (codigo) => ancestrosDe(codigo).length;

// Une lo que manda Punto V (id, codigo, nombre…) con el catálogo y lo agrupa
// en el orden de Punto V Manager. Dentro de cada grupo, cada hijo va justo
// después de su padre.
export const agruparPermisos = (disponibles) => {
  const grupos = new Map();
  for (const p of disponibles) {
    const cat = porCodigo.get(p.codigo);
    const grupo = cat?.grupo || SIN_CATALOGAR;
    const item = {
      ...p,
      nombre: cat?.nombre || p.nombre,
      descripcion: cat?.descripcion || p.descripcion,
      nivel: cat ? profundidad(p.codigo) : 0
    };
    grupos.set(grupo, [...(grupos.get(grupo) || []), item]);
  }

  const ordenCatalogo = new Map(CATALOGO.map((p, i) => [p.codigo, i]));
  const ordenar = (lista) => {
    const codigos = new Set(lista.map(p => p.codigo));
    const raices = lista.filter(p => !codigos.has(padre.get(p.codigo)));
    const conHijos = (p) => [p, ...lista
      .filter(h => padre.get(h.codigo) === p.codigo)
      .sort((a, b) => (ordenCatalogo.get(a.codigo) ?? 1e9) - (ordenCatalogo.get(b.codigo) ?? 1e9))
      .flatMap(conHijos)];
    return raices
      .sort((a, b) => (ordenCatalogo.get(a.codigo) ?? 1e9) - (ordenCatalogo.get(b.codigo) ?? 1e9))
      .flatMap(conHijos);
  };

  return [...ORDEN_GRUPOS, SIN_CATALOGAR]
    .filter(g => grupos.has(g))
    .map(g => ({ grupo: g, permisos: ordenar(grupos.get(g)) }));
};

// Marcar un permiso marca sus padres (sin "ver almacén" no sirve "crear
// factura"); desmarcarlo quita sus descendientes. Trabaja con códigos.
export const alternarPermiso = (seleccion, codigo, marcar, disponibles) => {
  const siguiente = new Set(seleccion);
  if (marcar) {
    [codigo, ...ancestrosDe(codigo)].filter(c => disponibles.has(c)).forEach(c => siguiente.add(c));
  } else {
    [codigo, ...descendientesDe(codigo)].forEach(c => siguiente.delete(c));
  }
  return siguiente;
};
